// Plain words for "Remember for me" (U6). No counts, no red, never "overdue".

/** The Undo toast after a note changed. */
export function noteMessage(previous: string | null, next: string): string {
  if (!next) return "Note removed.";
  return previous ? "Note updated. Only you can see it." : "Note saved. Only you can see it.";
}

function clock(iso: string): string {
  return new Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "2-digit" }).format(
    new Date(iso),
  );
}

/** "Remind me tomorrow" on the button, from the server's words for the reminder day. */
export function remindLabel(words: string | null): string {
  return words ? `Remind me ${words}` : "Remind me the day before";
}

/** The toast once a reminder exists: "I'll remind you tomorrow at 9:00 AM." */
export function reminderMessage(words: string | null, remindAt: string | null): string {
  if (!words || !remindAt) return "Reminder set.";
  return `I'll remind you ${words} at ${clock(remindAt)}.`;
}

/** The deadline line on a card: the email's own words, then what MeeMail offers. */
export function deadlineLine(quote: string): string {
  const words = quote.replace(/\s+/g, " ").trim();
  return `The email says: “${words.length > 160 ? `${words.slice(0, 157)}…` : words}”`;
}

/** The line for a thread that waits on the other side's own date. */
export function theirPromiseLine(quote: string): string {
  return `They said: “${quote.replace(/\s+/g, " ").trim()}” MeeMail waits until after that day before suggesting a nudge.`;
}
